import * as d3 from 'd3';

class Swarm {

	piep() {
		console.log("piep");
	}

	container(ref) {
		this.container = d3.select(ref);
		return this;
	}

	data(data) {
		this.data = data;
		// console.log(this.data);

		if (this.key === "totaal_euro_coal" || this.key === "totaal_euro_midstream" || this.key === "totaal_euro_upstream") {
			this.data = this.data.filter((d, i) => {
				return d["totaal_euro_coal"] !== "0";
			});
		}		

		if (this.key === "totaal_euro_midstream") {
			this.data.forEach((d,i) => {
				d["deelnemers_euro_midstream"] = parseInt(d["totaal_euro_midstream"]) / parseInt(d["aantal_deelnemers_en_ontvangers"]);
			});
			this.key = "deelnemers_euro_midstream";
		}


		if (this.key === "totaal_euro_upstream") {
			this.data.forEach((d,i) => {
				d["deelnemers_euro_upstream"] = parseInt(d["totaal_euro_upstream"]) / parseInt(d["aantal_deelnemers_en_ontvangers"]);
			});
			this.key = "deelnemers_euro_upstream";
		}


		if (this.key === "totaal_euro_coal") {
			this.data.forEach((d,i) => {
				d["deelnemers_euro_coal"] = parseInt(d["totaal_euro_coal"]) / parseInt(d["aantal_deelnemers_en_ontvangers"]);
			});
			this.key = "deelnemers_euro_coal";
		}

		return this;
	}

	key(key) {
		this.key = key;
		return this;
	}

	selected(fonds) {
		this.pensioenfonds = fonds;
		this.pensioenfondsdata = this.data.filter((d, i) => {
			return d["pensioenfonds"] === this.pensioenfonds;
		})[0];

		// console.log("selected for swarm: ", this.pensioenfonds, this.pensioenfondsdata);
		return this;
	}

	render(eerste) {
		this.container.select("svg").remove();

		if (this.pensioenfonds !== "Vervoer" && this.pensioenfonds !== "PNO") {
			this.renderContent(eerste);			
		}
		else if (this.key !== "deelnemers_euro_coal" && this.key !== "deelnemers_euro_midstream" && this.key !== "deelnemers_euro_upstream") {
			this.renderContent(eerste);
		}
		else {
			this.renderPlaceholder();
		}
	}

	renderPlaceholder() {
		this.graphic = this.container.append("svg")
			.attr("width", "100%")
			.attr("height", "50px")
			.attr("class", "knd-swarm-svg");

		this.graphic.append("text")
			.attr("x", 20)
			.attr("y", 25)
			.text("Jouw pensioenfonds geeft geen financiële data")
			.attr("class", "swarm-tekst highlight knd-klein");
	}

	renderContent(eerste) {
		this.height = 100;
		this.margin = {
			left: 20,
			right: 20
		};
		this.treshold = 50;
		this.extra = 0;

		if (eerste) {
			this.height = 200;
			this.extra = 50;
		}

		this.graphic = this.container.append("svg")
			.attr("width", "100%")
			.attr("height", this.height + "px")
			.attr("class", "knd-swarm-svg");

		this.width = this.graphic.node().getBoundingClientRect().width;
		
		this.min = d3.min(this.data, d => parseInt(d[this.key]));
		this.max = d3.max(this.data, d => parseInt(d[this.key]));

		this.minFonds = this.data[d3.minIndex(this.data, d => parseInt(d[this.key]))]
		this.maxFonds = this.data[d3.maxIndex(this.data, d => parseInt(d[this.key]))]

		this.xScale = d3.scaleLinear()
			.domain([this.min, this.max])
			.range([this.margin.left, (this.width - this.margin.right)]);

		this.scale = this.graphic.append("g")

		this.scale.append("line")
			.attr("x1", this.margin.left)
			.attr("x2", this.margin.left)
			.attr("y1", (this.height / 2) - 20)
			.attr("y2", (this.height / 2) + 20)
			.attr("class", "knd-swarm-scale");

		this.scale.append("line")
			.attr("x1", this.width - this.margin.right)
			.attr("x2", this.width - this.margin.right)
			.attr("y1", (this.height / 2) - 20)
			.attr("y2", (this.height / 2) + 20)
			.attr("class", "knd-swarm-scale");

		this.scale.append("line")
			.attr("x1", this.margin.left)
			.attr("x2", this.width - this.margin.right)
			.attr("y1", this.height / 2)
			.attr("y2", this.height / 2)
			.attr("class", "knd-swarm-scale");

		this.bollen = this.graphic.selectAll(".bollen")
			.data(this.data)
			.enter()
				.append("circle")
					.attr("cx", (d, i) => {
						return this.xScale(parseInt(d[this.key]));
					})
					.attr("cy", this.height / 2)
					.attr("r", 10)
					.attr("class", "bollen")
					.style("opacity", (d,i) => {
						if (isNaN(parseInt(d[this.key]))) {
							return 0;
						}
						else if (d["pensioenfonds"] === this.pensioenfonds) {
							return 1;
						}
						return .6;
					})
					.style("fill", (d,i) => {
						return  d["pensioenfonds"] === this.pensioenfonds ? "#E2FF9E" : "#fff";
					});

		this.highlight = this.graphic.append("g")

		this.highlight.append("line")
			.attr("x1", (d, i) => {
				return this.xScale(parseInt(this.pensioenfondsdata[this.key]));
			})
			.attr("x2", (d, i) => {
				return this.xScale(parseInt(this.pensioenfondsdata[this.key]));
			})
			.attr("y1", (this.height / 2) - 20)
			.attr("y2", (this.height / 2) + 20)
			.attr("class", "knd-swarm-scale highlight");

		// if (!eerste) {
			//minimum
			this.highlight.append("text")
				.attr("x", this.margin.left)
				.attr("y", this.height - 10 - this.extra)
				.text((d,i) => {
					// if (this.key === "totaal_euro_coal" || this.key === "totaal_euro_midstream" || this.key === "totaal_euro_upstream") {
					// 	return (Math.round(this.min / 10000000) / 100).toString().replace(".", ",");
					// }
					return this.min;
				})
				.attr("class", "swarm-tekst center knd-klein")
				.style("visibility", (d,i) => {
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) < this.treshold) {
						return "hidden";
					}
					return "visible";
				});

			this.highlight.append("text")
				.attr("x", this.margin.left - 10)
				.attr("y", 20 + this.extra)
				.text(this.minFonds["pensioenfonds"])
				.attr("class", "swarm-tekst rechts knd-klein")
				.style("visibility", (d,i) => {
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) < this.treshold) {
						return "hidden";
					}
					return "visible";
				});

			//maxiumu
			this.highlight.append("text")
				.attr("x", this.width - this.margin.right)
				.attr("y", this.height - 10 - this.extra)
				.text((d,i) => {
					// if (this.key === "totaal_euro_coal" || this.key === "totaal_euro_midstream" || this.key === "totaal_euro_upstream") {
					// 	return (Math.round(this.max / 100000000) / 10).toString().replace(".", ",");
					// }
					return this.max;
				})
				.attr("class", "swarm-tekst center knd-klein")
				.style("visibility", (d,i) => {
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) > (this.width - this.treshold)) {
						return "hidden";
					}
					return "visible";
				});

			this.highlight.append("text")
				.attr("x", this.width - this.margin.right + 10)
				.attr("y", 20 + this.extra)
				.text(this.maxFonds["pensioenfonds"])
				.attr("class", "swarm-tekst links knd-klein")
				.style("visibility", (d,i) => {
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) > (this.width - this.treshold)) {
						return "hidden";
					}
					return "visible";
				});

			//highlight
			this.highlight.append("text")
				.attr("x", () => {
					const loc = this.xScale(parseInt(this.pensioenfondsdata[this.key]));
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) > (this.width - this.treshold)) {
						return loc + 10;
					}
					else if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) < this.treshold) {
						return loc - 10;
					}
					return loc;
				})
				.attr("y", 20 + this.extra)
				.text(this.pensioenfonds)
				.attr("class", "swarm-tekst knd-klein center highlight")
				.style("text-anchor", () => {
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) > (this.width - this.treshold)) {
						return "end";
					}
					else if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) < this.treshold) {
						return "start";
					}
					return "middle";
				})

			this.highlight.append("text")
				.attr("x", (d, i) => {
					return this.xScale(parseInt(this.pensioenfondsdata[this.key]));
				})
				.attr("y", this.height - 10 - this.extra)
				.text(() => {
					// if (this.key === "totaal_euro_coal" || this.key === "totaal_euro_midstream" || this.key === "totaal_euro_upstream") {
					// 	return (Math.round(this.pensioenfondsdata[this.key] / 100000000) / 10).toString().replace(".", ",");
					// }
					return Math.round(this.pensioenfondsdata[this.key]);
				})
				.attr("class", "swarm-tekst knd-klein center highlight")
		// }
		if (eerste) {
			//voorbeeldgrafiek

			this.highlight.append("text")
				.attr("x", (d, i) => {
					const loc = this.xScale(parseInt(this.pensioenfondsdata[this.key]));
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) > (this.width - this.treshold)) {
						return loc + 10;
					}
					else if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) < this.treshold) {
						return loc - 10;
					}
					return loc;
				})
				.attr("y", 25)
				.text("Jouw")
				.attr("class", "swarm-tekst knd-klein center highlight")
				.style("text-anchor", () => {
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) > (this.width - this.treshold)) {
						return "end";
					}
					else if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) < this.treshold) {
						return "start";
					}
					return "middle";
				})
				.style("visibility", () => {
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) < (this.width - this.treshold) && this.xScale(parseInt(this.pensioenfondsdata[this.key])) > this.treshold) {
						return "visible";
					}
					return "hidden";
				})

			this.highlight.append("text")
				.attr("x", (d, i) => {
					const loc = this.xScale(parseInt(this.pensioenfondsdata[this.key]));
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) > (this.width - this.treshold)) {
						return loc + 10;
					}
					else if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) < this.treshold) {
						return loc - 10;
					}
					return loc;
				})
				.attr("y", 40)
				.text("pensioenfonds")
				.attr("class", "swarm-tekst knd-klein center highlight")
				.style("text-anchor", () => {
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) > (this.width - this.treshold)) {
						return "end";
					}
					else if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) < this.treshold) {
						return "start";
					}
					return "middle";
				})
				.style("visibility", () => {
					if (this.xScale(parseInt(this.pensioenfondsdata[this.key])) < (this.width - this.treshold) && this.xScale(parseInt(this.pensioenfondsdata[this.key])) > this.treshold) {
						return "visible";
					}
					return "hidden";
				})

			this.highlight.append("text")
				.attr("x", 0)
				.attr("y", 10)
				.text("Pensioenfonds")
				.attr("class", "swarm-tekst knd-klein");

			this.highlight.append("text")
				.attr("x", 0)
				.attr("y", 25)
				.text("met de minste")
				.attr("class", "swarm-tekst knd-klein");

			this.highlight.append("text")
				.attr("x", 0)
				.attr("y", 40)
				.text("steenkoolbedrijven")
				.attr("class", "swarm-tekst knd-klein");

			this.highlight.append("text")
				.attr("x", this.width)
				.attr("y", 10)
				.text("Pensioenfonds")
				.attr("class", "swarm-tekst knd-klein links");

			this.highlight.append("text")
				.attr("x", this.width)
				.attr("y", 25)
				.text("met de meeste")
				.attr("class", "swarm-tekst knd-klein links");

			this.highlight.append("text")
				.attr("x", this.width)
				.attr("y", 40)
				.text("steenkoolbedrijven")
				.attr("class", "swarm-tekst knd-klein links");
		}

		if (eerste) {
			//smileys
			//https://stackoverflow.com/questions/52078955/add-a-smiley-face-to-a-svg-circle
			let xPos = this.margin.left;
			let yPos = this.height / 2;
			let radius = 10;

			let arc = d3.arc()
				.startAngle(1.8 * (Math.PI / 2))
				.endAngle(2.2 * (Math.PI / 2))
				.innerRadius(radius / .8)
				.outerRadius(radius / .87);

			this.graphic.append("circle")
				.attr("cx", xPos)
				.attr("cy", yPos)
				.attr("r", radius)
				.style("fill", "#fff")

			this.graphic.append("circle")
				.attr("cx", xPos - radius / 3)
				.attr("cy", yPos - radius / 3)
				.attr("r", radius / 8)
				.style("fill", "#4D00FF");

			this.graphic.append("circle")
				.attr("cx", xPos + radius / 3)
				.attr("cy", yPos - radius / 3)
				.attr("r", radius / 8)
				.style("fill", "#4D00FF");

			this.graphic.append("path")
				.attr("d", arc)
				.attr("transform", "translate(" + xPos + "," + (yPos * .92) + ")")
				.style("fill", "#4D00FF");

			xPos = this.width - this.margin.right;
			yPos = this.height / 2;

			arc = d3.arc()
				.startAngle(3.2 * (Math.PI / 2))
				.endAngle(4.8 * (Math.PI / 2))
				.innerRadius(radius / 2)
				.outerRadius(radius / 2.4);

			this.graphic.append("circle")
				.attr("cx", xPos)
				.attr("cy", yPos)
				.attr("r", radius)
				.style("fill", "#fff")

			this.graphic.append("circle")
				.attr("cx", xPos - radius / 3)
				.attr("cy", yPos - radius / 3)
				.attr("r", radius / 8)
				.style("fill", "#4D00FF");

			this.graphic.append("circle")
				.attr("cx", xPos + radius / 3)
				.attr("cy", yPos - radius / 3)
				.attr("r", radius / 8)
				.style("fill", "#4D00FF");

			this.graphic.append("path")
				.attr("d", arc)
				.attr("transform", "translate(" + xPos + "," + (yPos + (radius / 1.8)) + ")")
				.style("fill", "#4D00FF");
		}
	}
}

export default Swarm;